<template>
  <main class="category">
    <ContentsHeader />
    <article class="main_content">
      <div class="pankuzu">
        <ol class="breadcrumb float-sm-right">
          <li class="breadcrumb-item"><a :href="topurl()">トップ</a></li>
          <li class="breadcrumb-item active">キーワード一覧</li>
        </ol>
      </div>

      <div class="lp_link_list__wrapper">
        <section class="top_link_list">
          <div class="category_link_list_session">
            <h2 class="category_link_list_session__header">キーワード一覧</h2>
            <ul class="category_link_list_session__list" v-if="true">
              <template v-for="(item, index) in page.keywords" :key="index">
                <li
                  class="category_link_list_session__item"
                  :class="[
                    page.keywords.length == index + 1
                      ? 'category_link_list_session__item--last'
                      : '',
                  ]"
                >
                  <a
                    class="category_link_list_session__item_link"
                    :href="klpurl(item.getId(), item.getTitle())"
                    >{{ item.getTitle() }}</a
                  >
                  <img
                    class="category_link_list_session__icon"
                    src="@/assets/arrow_right.svg"
                  />
                </li>
              </template>
            </ul>
          </div>
        </section>
      </div>
      <div class="border_divider"></div>
    </article>
    <ContentsFooter :pager="pager" />
  </main>
</template>

<script>
// @ is an alias to /src

// eslint-disable-next-line
import tacklebox from "tacklebox";
import ContentsHeader from "@/components/ContentsHeader.vue";
import ContentsFooter from "@/components/ContentsFooter.vue";

import { KeywordPage } from "@/js/page/KeywordPage.js";

export default {
  name: "KeywordView",
  data() {
    return {
      page: new KeywordPage(),
      isNetworking: false,
    };
  },
  mounted() {
    this.pager.changePage(this.page);

    document.title = "FitGap | 自社にぴったりのサービスを選ぶための無料診断 ";
  },
  beforeUnmount() {
    //
  },
  methods: {
    lpurl(id, title) {
      return process.env.VUE_APP_SELF + "/#/search/" + id + "?title=" + title;
    },
    klpurl(id, title) {
      return process.env.VUE_APP_SELF + "/#/ksearch/" + id + "?title=" + title;
    },
    categoryurl() {
      return process.env.VUE_APP_SELF + "/#/category";
    },
    kwurl() {
      return process.env.VUE_APP_SELF + "/#/keyword";
    },
    topurl() {
      return process.env.VUE_APP_SELF;
    },
  },
  components: {
    ContentsFooter,
    ContentsHeader,
  },
  props: {
    pager: Object,
  },
};
</script>
